const VOICE_LESSON_CONTEXT_EVENT = 'budleeVoiceLessonContextChanged';

let activeVoiceLessonContext = null;

export function publishVoiceLessonContext(context) {
  activeVoiceLessonContext = context && typeof context === 'object' ? context : null;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(VOICE_LESSON_CONTEXT_EVENT, {
      detail: activeVoiceLessonContext,
    }));
  }
}

export function getVoiceLessonContext() {
  return activeVoiceLessonContext;
}

export function subscribeToVoiceLessonContext(callback) {
  if (typeof callback !== 'function') return () => {};
  callback(activeVoiceLessonContext);
  if (typeof window === 'undefined') return () => {};

  const handleChange = (event) => callback(event.detail || null);
  window.addEventListener(VOICE_LESSON_CONTEXT_EVENT, handleChange);
  return () => window.removeEventListener(VOICE_LESSON_CONTEXT_EVENT, handleChange);
}
